import { render, staticRenderFns } from "./ProductStockForm.vue?vue&type=template&id=41efc822&"
import script from "./ProductStockForm.vue?vue&type=script&lang=js&"
export * from "./ProductStockForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41efc822')) {
      api.createRecord('41efc822', component.options)
    } else {
      api.reload('41efc822', component.options)
    }
    module.hot.accept("./ProductStockForm.vue?vue&type=template&id=41efc822&", function () {
      api.rerender('41efc822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/basic/stock/modules/ProductStockForm.vue"
export default component.exports